export default function getRolesTransformer(data) {
    const transformedPayload = {};
    try {
        const payload = JSON.parse(data);
        Object.keys(payload.Roles).forEach((role) => {
            const roleKey = payload.Roles[role];
            transformedPayload[role] = {
                key: roleKey,
                text: role,
                value: role,
                checked: false,
                indeterminate: false,
                count: '',
            };
        });
        return transformedPayload;
    } catch (error) {
        // swallow and return the payload as-is so axios can handle it.
    }
    return data;
}
